import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getDeviceProfileChannels = async (authHelper: AuthHelper, organizationId: string, deviceprofileId: string) => {
    const deviceProfileChannelsResponse = await ApiRequests.deviceProfileChannels(
        {
            organizationId: organizationId,
            deviceprofileId: deviceprofileId
        },
        { authHelper }
    );
    if (!deviceProfileChannelsResponse.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(deviceProfileChannelsResponse.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(deviceProfileChannelsResponse.response));
    }

    return deviceProfileChannelsResponse.response.data.deviceProfileChannels;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getChildProfileDetails = async (authHelper: AuthHelper, organizationId: string, deviceprofileId: string) => {
    const ChildProfileDetailsResponse = await ApiRequests.childProfileDetails(
        {
            organizationId: organizationId,
            deviceprofileId: deviceprofileId
        },
        { authHelper }
    );
    if (!ChildProfileDetailsResponse.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(ChildProfileDetailsResponse.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(ChildProfileDetailsResponse.response));
    }

    return ChildProfileDetailsResponse.response.data;
};


export {getDeviceProfileChannels,getChildProfileDetails};
